<template>
  <validation-observer v-if="aditivo" ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvarAditivo)">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              {{ isEdit ? 'Editar' : 'Cadastrar' }} Aditivo de contrato
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="4">
              <b-col id="input-group-selectContrato" cols="12">
                <span class="d-block text-left pb-1">Contrato</span>
                <validation-provider tag="div" rules="required" v-slot="validationContext" name="contrato">
                  <div id="contratoSelectWrapper"
                    :class="{ 'invalid': (validationContext.errors.length > 0) || (aditivo.IdContrato <= 0), 'valid': (aditivo.IdContrato > 0) }">
                    <multiselect @input="updateSelectContrato" v-model="contratoSelecionado" open-direction="bottom"
                      :close-on-select="true" :searchable="true" deselect-label="" :allow-empty="true"
                      placeholder="SELECIONE UMA OPÇÃO" track-by="Codigo" :options="listaContratos" label="Nome"
                      :show-labels="false">
                      <template #noOptions>
                        <small><i>Erro ao obter dados.</i></small>
                      </template>
                      <template #noResult>
                        <i>Sem resultados.</i>
                      </template>
                    </multiselect>
                    <label class="typo__label form__label" v-if="validationContext.errors.length > 0">{{
                      validationContext.errors[0] }}</label>
                  </div>
                </validation-provider>
              </b-col>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required|min_value:1" v-slot="validationContext" name="tipoAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Tipo do Termo Aditivo *" label-cols="auto"
                  content-cols="12">
                  <b-form-select id="select-tipoAditivo" v-model="aditivo.IdTipoTermoAditivo" :options="listaTiposAditivo"
                    @change="handleTipoAditivoChange" :state="getValidationState(validationContext)">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-tipoAditivo-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required|min_value:1" v-slot="validationContext" name="naturezaAjuste">
                <b-form-group id="input-group-type" label-size="md" label="Natureza do Ajuste *" label-cols="auto"
                  content-cols="12">
                  <b-form-select id="select-naturezaAjuste" v-model="aditivo.IdNaturezaAjuste"
                    :disabled="aditivo.IdTipoTermoAditivo <= 0" :options="listaNaturezasAjuste"
                    @change="handleTipoNaturezaAjusteChange" :state="getValidationState(validationContext)">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-naturezaAjuste-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
            <b-col cols="2">
              <validation-provider rules="required" v-slot="validationContext" name="numeroAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Nº Aditivo *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-numeroAditivo" v-model="aditivo.NrAditivoContrato"
                    :state="getValidationState(validationContext)" type="number"></b-form-input>
                  <b-form-invalid-feedback id="input-numeroAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="2">
              <validation-provider rules="required" v-slot="validationContext" name="numeroAnoAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Ano Aditivo *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-numeroAnoAditivo" v-model="aditivo.NrAnoAditivoContrato"
                    :state="getValidationState(validationContext)" type="number"></b-form-input>
                  <b-form-invalid-feedback id="input-numeroAnoAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required" v-slot="validationContext" name="justificativaAditivo">
                <b-form-group id="justificativaAditivo-input-group" label="Justificativa *"
                  label-for="input-justificativaAditivo" label-cols="auto" content-cols="12">
                  <b-form-textarea id="input-justificativaAditivo" :state="getValidationState(validationContext)"
                    v-model="aditivo.DeJustificativaAditivo" rows="3" max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback id="input-justificativaAditivo-live-feedback">{{ validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="4">
              <b-form-group class="formGroup mb-5" id="arquivo-input-group"
                label="Arquivo Texto do Termo Aditivo do Contrato (.pdf) *" label-for="input-arquivo" label-cols="auto"
                content-cols="12">
                <validation-provider v-if="!existeArquivo()" rules="required" v-slot="validationContext" name="arquivo">
                  <b-form-file v-model="arquivoForm" :state="getValidationState(validationContext)"
                    placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..." class=""
                    browse-text="Escolher" accept=".pdf"></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback">{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
                <div v-else class="d-flex justify-content-center">
                  <btn-download class="mr-2" :fazerDownload="baixarAnexo" :parametros="arquivo" />
                  <b-link class="text-dark" @click="removerArquivo()">
                    <font-awesome-icon icon="times" />
                    <div style="font-size: 12px">Remover</div>
                  </b-link>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-inicio-input-group" label="Início de vigência"
                label-for="input-data-inicio">
                <b-form-datepicker id="input-data-inicio" v-model="aditivo.DtInicioVigenciaAditivo"
                  :disabled="isVigenciaDisabled && !isAlteracaoSubjetiva" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" reset-button label-reset-button="Limpar"
                  label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                  label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                  label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-fim-input-group" label="Fim de vigência"
                label-for="input-data-fim">
                <b-form-datepicker id="input-data-fim" v-model="aditivo.DtFimVigenciaAditivo"
                  :disabled="isVigenciaDisabled && !isAlteracaoSubjetiva" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" reset-button label-reset-button="Limpar"
                  label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                  label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                  label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <validation-provider :rules="isValorDisabled ? '' : 'required'" v-slot="validationContext"
                name="valorAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Valor do Aditamento/Supressão (R$)"
                  label-cols="auto" content-cols="12">
                  <money class="form-control" id="input-valorAditivo" :disabled="isValorDisabled"
                    v-model="aditivo.VlAditivoContrato" v-bind="vMoneyOptions"
                    :state="getValidationState(validationContext)" />
                  <b-form-invalid-feedback id="input-valorAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" rules="required" id="data-publicacao-input-group"
                label="Data de Publicação *" label-for="input-data-publicacao">
                <b-form-datepicker id="input-data-publicacao" v-model="aditivo.DtPublicacaoAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" rules="required" id="data-assinatura-input-group"
                label="Data de Assinatura *" label-for="input-data-assinatura">
                <b-form-datepicker id="input-data-assinatura" v-model="aditivo.DtAssinaturaAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-anulacao-input-group" label="Data de Anulação"
                label-for="input-data-anulacao">
                <b-form-datepicker id="input-data-anulacao" v-model="aditivo.DtAnulacaoAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano" @input="handleDataAnulacaoInput">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="isMotivoAnulacaoAvailable">
              <validation-provider v-slot="validationContext" rules="required" name="justificativaAnulacao">
                <b-form-group id="justificativaAnulacao-input-group" label="	Motivo da Anulação"
                  label-for="input-justificativaAnulacao" label-cols="auto" content-cols="12">
                  <b-form-textarea id="input-justificativaAnulacao" :state="getValidationState(validationContext)"
                    v-model="aditivo.DeMotivoAnulacaoAditivo" rows="3" max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback id="input-justificativaAnulacao-live-feedback">{{ validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- Só mostra se o tipo for Alteração subjetiva -->
          <b-row v-if="isAlteracaoSubjetiva">
            <b-col class="my-2" cols="12">
              <span><strong>Informações do novo contratado</strong></span>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required" v-slot="validationContext" name="cpfContratado">
                <b-form-group id="input-group-type" label-size="md" label="CPF/CNPJ *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-cpfContratado" v-model="aditivo.CdCpfCnpjParticipante"
                    :state="getValidationState(validationContext)" type="text"></b-form-input>
                  <b-form-invalid-feedback id="input-cpfContratado-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required" v-slot="validationContext" name="nomeContratado">
                <b-form-group id="input-group-type" label-size="md" label="	Nome/Razão Social *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-nomeContratado" v-model="aditivo.NmParticipante"
                    :state="getValidationState(validationContext)" type="text"></b-form-input>
                  <b-form-invalid-feedback id="input-nomeContratado-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required" v-slot="validationContext" name="justificativaAlteracaoSubjetiva">
                <b-form-group id="input-group-type" label-size="md" label="	Justificativa da Alteração Subjetiva *"
                  label-cols="auto" content-cols="12">
                  <b-form-select id="select-justificativaAlteracaoSubjetiva"
                    v-model="aditivo.DeJustificativaAlteracaoSubjetiva" :options="listaTiposAlteracaoSubjetiva"
                    :state="getValidationState(validationContext)">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-justificativaAlteracaoSubjetiva-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import BtnVoltar from '@/components/shared/BtnVoltar.vue';
import BtnDownload from '@/components/shared/btn-download.vue';
import aditivosContratoService from '@/services/licitacoes/aditivosContratoService';
import { store } from "@/store";
import { AditivoContrato } from '@/types/licitacoes/aditivo-contrato/aditivo-contrato';
import { ArquivoAditivo } from '@/types/licitacoes/arquivo-aditivo';
import { TiposAditivoContratoEnum } from '@/types/licitacoes/enums/tipos-aditivos-contrato';
import { TiposNaturezaAjusteEnum } from '@/types/licitacoes/enums/tipos-natureza-ajuste';
import { TipoTermoAditivo } from '@/types/licitacoes/tipo-termo-aditivo';
import { UtilsTS } from '@/utilsts';
import { Money } from 'v-money';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mixins } from 'vue-class-component';
import Multiselect from "vue-multiselect";
import { Component, Vue } from 'vue-property-decorator';

const CompProps = Vue.extend({
  name: 'EditarAditivo',
  components: { BtnVoltar, BtnDownload, Money, Multiselect, ValidationProvider, ValidationObserver },
  props: {
    idAditivo: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarAditivoContrato extends mixins(UtilsTS, CompProps) {
  listaContratos: any[] = []
  listaTiposAditivo: TipoTermoAditivo[] = []
  listaNaturezasAjuste: any[] = []
  listaNaturezasAjusteCompleta: any[] = []
  listaTiposAlteracaoSubjetiva = [{ value: '', text: 'SELECIONE UMA OPÇÃO', disabled: true }, { value: 'CISÃO', text: 'CISÃO' }, { value: 'ESPÓLIO', text: 'ESPÓLIO' }, { value: 'FUSÃO', text: 'FUSÃO' }, { value: 'INCORPORAÇÃO', text: 'INCORPORAÇÃO' }]
  tableBusy = false
  aditivo: AditivoContrato = new AditivoContrato()
  arquivo: ArquivoAditivo = new ArquivoAditivo()
  arquivoForm = null
  isAlteracaoSubjetiva = false
  isVigenciaDisabled = true
  isValorDisabled = true
  isMotivoAnulacaoAvailable = false
  contratoSelecionado: any = null

  get isEdit() {
    return this.idAditivo !== undefined && this.idAditivo !== null
  }

  updateSelectContrato() {
    this.aditivo.IdContrato = this.contratoSelecionado.Codigo;
  }

  handleDataAnulacaoInput(): void {
    this.isMotivoAnulacaoAvailable = this.aditivo.DtAnulacaoAditivo != null
    if (!this.isMotivoAnulacaoAvailable)
      this.aditivo.DeMotivoAnulacaoAditivo = null
  }

  handleTipoNaturezaAjusteChange() {
    this.isValorDisabled = this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_PRAZO ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_SEM_ALTERACAO ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO;

    this.isVigenciaDisabled = this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.ACRESCIMO_VALOR ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_SEM_ALTERACAO ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.SUPRESSAO_VALOR;

    if (this.isVigenciaDisabled) {
      this.aditivo.DtInicioVigenciaAditivo = null;
      this.aditivo.DtFimVigenciaAditivo = null;
    }

    if (this.isValorDisabled) {
      this.aditivo.VlAditivoContrato = null;
    }
  }

  handleTipoAditivoChange() {
    this.isAlteracaoSubjetiva = false
    this.isVigenciaDisabled = true
    this.isValorDisabled = true

    this.isAlteracaoSubjetiva = this.aditivo.IdTipoTermoAditivo == TiposAditivoContratoEnum.ALTERACAO_SUBJETIVA
    this.aditivo.IdNaturezaAjuste = 0
    if (this.isAlteracaoSubjetiva) {
      this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO ||
        x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR ||
        x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)
    }
    else {
      this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO &&
        x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR &&
        x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)
      this.aditivo.CdCpfCnpjParticipante = null;
      this.aditivo.NmParticipante = null;
      this.aditivo.DeJustificativaAlteracaoSubjetiva = null;
    }
  }

  async mounted() {
    try {
      store.blockScreen = true

      if (this.isEdit) {
        const aditivoApi = await aditivosContratoService.buscarAditivo(this.idAditivo)
        if (aditivoApi && aditivoApi.status === 200) {
          this.aditivo = Object.assign(this.aditivo, aditivoApi.data)
          this.aditivo.tratarDadosDaAPI()
          this.arquivo = this.aditivo.ArquivoAditivoContrato.length > 0 ? Object.assign(this.arquivo, this.aditivo.ArquivoAditivoContrato[0]) : new ArquivoAditivo()
          this.isAlteracaoSubjetiva = this.aditivo.IdTipoTermoAditivo == TiposAditivoContratoEnum.ALTERACAO_SUBJETIVA
          this.handleTipoNaturezaAjusteChange()
          this.handleDataAnulacaoInput()
        } else {
          this.$router.push("/modulo-licitacoes/aditivos-contratos");
          this.$toast.error(aditivoApi.data.msg || "Erro ao carregar aditivo");
        }
      }
      else {
        this.aditivo.IdTipoTermoAditivo = 0
        this.aditivo.IdContrato = 0
        this.aditivo.IdNaturezaAjuste = 0
        this.aditivo.ArquivoAditivoContrato = []
        this.aditivo.DeJustificativaAlteracaoSubjetiva = ''
      }
      const responseContratos = await aditivosContratoService.listarContratos()
      const responseTiposAditivo = await aditivosContratoService.listarTiposAditivo()
      const responseNaturezasAjuste = await aditivosContratoService.listarNaturezasAjuste()

      this.listaContratos = [...responseContratos.data.map(c => {
        const limiteDescricao = 70
        const descricaoContrato = c.DeObjetoContrato.length > limiteDescricao ? c.DeObjetoContrato.substring(0, limiteDescricao) + "..." : c.DeObjetoContrato
        return { Codigo: c.IdContrato, Nome: `${c.NrContrato}/${c.NrAnoContrato} - ${descricaoContrato}` }
      }
      )]

      if (this.isEdit) {
        this.contratoSelecionado = this.listaContratos.find(x => x.Codigo === this.aditivo.IdContrato)
      }

      this.listaTiposAditivo = [{ value: 0, text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseTiposAditivo.data.map(t => ({ value: t.IdTipoTermoAditivo, text: t.DeTipoTermoAditivo }))]
      this.listaNaturezasAjuste = [{ value: 0, text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseNaturezasAjuste.data.map(t => ({ value: t.IdNaturezaAjuste, text: t.DeNaturezaAjuste }))]
      this.listaNaturezasAjusteCompleta = this.listaNaturezasAjuste
      if (this.isAlteracaoSubjetiva) {
        this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO ||
          x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR ||
          x.value == TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)
      }
      else {
        this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO &&
          x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR &&
          x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)
      }
    } catch (e: any) {
      console.error('Erro ao montar edição de aditivo de contrato', e)
      this.$router.push("/modulo-licitacoes/aditivos-contratos");
      this.$toast.error(e.message || "Erro ao carregar aditivo de contrato");
    } finally {
      store.blockScreen = false
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  existeArquivo() {
    return this.arquivo.IdAditivoContrato > 0 ? true : false
  }

  async removerArquivo() {
    this.arquivo = new ArquivoAditivo()
  }

  async baixarAnexo(arquivo: ArquivoAditivo) {
    const response = await aditivosContratoService.baixarAnexo(arquivo.IdArquivo)
    this.download(arquivo.DeNomeArqTextoAditivo, response.data)
  }
  async salvarAditivo() {
    try {
      const response = this.isEdit ? await aditivosContratoService.editarAditivo(this.aditivo, this.arquivoForm) : await aditivosContratoService.adicionarAditivo(this.aditivo, this.arquivoForm)
      if (response && response.status === 200) {
        this.$toast.success('Aditivo salvo com sucesso.')
        this.$router.push('/modulo-licitacoes/aditivos-contratos')
      }
      else if (response && [400,403].includes(response.status) && response.data.erros) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: false
          });
        });
      }
      else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar aditivo.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
};
</script>

<style>
#input-group-selectContrato {
  padding: 0;
  padding-top: 2% !important;
}

#input-group-selectContrato .multiselect {
  width: 100%;
  max-width: 100%;
}

#input-group-selectContrato .multiselect__tags {
  border: #ced4da solid 1px !important;
  border-radius: 3px !important;
}

#input-group-selectContrato .multiselect__option {
  padding: 6px !important;
  min-height: 0;
  font-size: 16px;
}

#input-group-selectContrato .multiselect__option--selected {
  color: #495057 !important;
  background: #fff;
  font-weight: 400;
}

#input-group-selectContrato .multiselect__content-wrapper {
  border: 1px solid #ced4da;
  max-height: 200px !important;
}

#input-group-selectContrato .multiselect__option--highlight {
  background: #007bff !important;
  color: #fff !important;
}

#input-group-selectContrato .multiselect__input,
.multiselect__single {
  background-color: #fff !important;
  color: #495057 !important;
}

#input-group-selectContrato .multiselect__input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #495057 !important;
}

#input-group-selectContrato .multiselect__input::active {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

#input-group-selectContrato .multiselect__tags {
  background-color: #fff;
  color: #495057 !important;
  border-radius: 2px;
}

#input-group-selectContrato .multiselect__select:before {
  color: #495057 !important;
  border-color: #495057 transparent transparent !important;
}

#input-group-selectContrato .multiselect {
  z-index: 2;
}

#input-group-selectContrato .multiselect__placeholder {
  color: #495057;
  font-weight: 400;
  font-size: 1rem;
}

#input-group-selectContrato .multiselect__single {
  cursor: pointer;
}

#input-group-selectContrato .multiselect__input,
#input-group-selectContrato .multiselect__single {
  vertical-align: initial;
}

#input-group-selectContrato .multiselect--disabled .multiselect__tags,
#input-group-selectContrato .multiselect--disabled .multiselect__tags span {
  color: #6c757d !important;
}

#input-group-selectContrato .multiselect--disabled .multiselect__select {
  background: #fff !important;
}

#contratoSelectWrapper.invalid .multiselect__tags {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

#contratoSelectWrapper.valid .multiselect__tags {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

#contratoSelectWrapper label {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>